export default (collection, cb) => {
  if (Array.isArray(collection)) {
    collection.forEach(cb);
    return;
  }

  const keys = Object.keys(collection);

  keys.forEach((key) => {
    const val = collection[key];
    cb(val, key);
  });
};
